<template>
  <v-app>
    <v-app-bar :elevation="noElevation ? 0 : 4" app color="#272d44" dark fixed>
      <div class="title-text_wrapper">
        <v-toolbar-title class="titleText" v-text="title" />
      </div>
      <div class="back-btn_wrapper">
        <v-btn v-if="showBackBtn" dark icon @click="back()">
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { createComponent, value } from "vue-function-api";
import store from "@/store";
import SubscReConnectComponent from "@/framework/components/SubscReConnect.vue";
import { i18n } from "../plugins/i18n";
import { ComponentMutation } from "@/framework/store/component/types";
import { VoiceChatMutation } from "@/modules/voiceChat/store/types";

export default createComponent({
  components: {
    SubscReConnectComponent,
  },
  setup(props, context) {
    const $router = context.root.$router;
    const title = value("");
    const signedUp = value(false);
    const showBackBtn = value(false);
    const noElevation = value(false);

    store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case VoiceChatMutation.SET_HIDE_NOTIFICATION_LABEL:
          title.value = "";
          noElevation.value = true;
          break;
        case ComponentMutation.SET_NAVIGATION:
          title.value = mutation.payload.title;
          signedUp.value = mutation.payload.signedUp;
          break;
        case ComponentMutation.SET_NAVIGATION_UPDATE:
          if (mutation.payload.title != null) title.value = mutation.payload.title;
          if (mutation.payload.showBackBtn != null) showBackBtn.value = mutation.payload.showBackBtn;
          break;
      }
    });

    const back = () => {
      $router.push(`/${i18n.locale}/conversations`);
    };

    return {
      title,
      signedUp,
      back,
      showBackBtn,
      noElevation,
    };
  },
});
</script>

<style scoped>
.titleText {
  text-align: center;
}

.back-btn_wrapper {
  position: absolute;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.title-text_wrapper {
  position: absolute;
  /* なぜかずれるのでその調整 */
  -webkit-padding-end: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
